import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text} from "pixi.js";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class UnderlineMark extends Mark implements IMark
{
    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void
    {
        this.markWidth = 80;
        this.markHeight = this.strokeThickness;
        if(this.targetTextField)
        {
            this.padding = this.adjustToScale(12);
            this.parentTarget = this.targetTextField;
            const fontSize = Number(this.targetTextField.style.fontSize);
            this.targetTextFieldStyle = this.targetTextField.style;
            this.strokeThickness = Number(this.targetTextFieldStyle.fontSize)/20;
            this.markWidth = this.targetTextField.width;
            this.markX = 5;
            this.markY = this.targetTextField.height/2 + (this.adjustToScale(90)*this.multipleOfDefaultFontSize);
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        let underlineLength = this.markWidth-(this.padding*2);

        let mark = new Graphics();
        mark.moveTo(this.strokeThickness / 2, this.strokeThickness / 2);
        mark.lineTo(this.strokeThickness / 2 + underlineLength, this.strokeThickness / 2);
        mark.stroke({width:this.strokeThickness, color:color, cap:"round"});
        mark.x = this.padding/2;
        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks():void
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}